import React, { useRef, useEffect, useCallback } from "react";
import { Button } from "@speedoc/design-assets";
import { useHistory } from "react-router-dom";
import URI from "urijs";
import { ChevronBlue } from "@speedoc/design-assets/build/icons/index";

export default function Tabs({ flexDirection, buttonDetails, activeIndex }) {
  const history = useHistory();
  const tabsRef = useRef();
  const buttonRefs = buttonDetails.map(useRef);
  const showTabs = buttonRefs?.length > 4;
  const showPrev = activeIndex - 1 > -1;
  const showNext = activeIndex + 1 < buttonDetails?.length;

  const offset = useCallback(() => {
    setTimeout(() => {
      if (tabsRef.current) {
        const { offsetWidth: tabWidth } = tabsRef.current;
        const { offsetLeft, offsetWidth: btnWidth } = buttonRefs[activeIndex].current;
        tabsRef.current.scrollLeft = offsetLeft - (tabWidth - btnWidth) / 2;
      }
    }, 500);
  }, [activeIndex, buttonRefs]);

  const handleChangeFilter = index => {
    history.replace(new URI(history.location).addSearch({ tag: index }).search());
    offset();
  };

  useEffect(() => {
    offset();
  }, [offset]);

  return (
    <div className="tabsMasterContainer">
      {showTabs && showPrev && (
        <div
          className="chevronContainer left"
          onClick={() => handleChangeFilter(activeIndex - 1, buttonRefs[activeIndex - 1])}>
          <ChevronBlue />
        </div>
      )}
      <div ref={tabsRef} className="tabsContainer">
        <div className="tabs" style={{ flexDirection }}>
          {buttonDetails.map(({ title, classes, ...rest }, i) => (
            <div ref={buttonRefs[i]} key={i}>
              <Button
                onClick={() => handleChangeFilter(i, buttonRefs[i])}
                className={classes || "secondary sm"}
                {...rest}>
                {title}
              </Button>
            </div>
          ))}
        </div>
      </div>
      {showTabs && showNext && (
        <div
          className="chevronContainer"
          onClick={() => handleChangeFilter(activeIndex + 1, buttonRefs[activeIndex + 1])}>
          <ChevronBlue />
        </div>
      )}
    </div>
  );
}

export function SimpleTabs({ flexDirection, buttonDetails, onClick }) {
  const buttonRefs = buttonDetails.map(useRef);

  return (
    <div className="tabs" style={{ flexDirection }}>
      {buttonDetails.map(({ title, text, classes, ...rest }, i) => (
        <div ref={buttonRefs[i]} key={i}>
          <Button onClick={() => onClick(i, buttonRefs[i])} className={classes || "secondary sm"} {...rest}>
            {title || text}
          </Button>
        </div>
      ))}
    </div>
  );
}
